export const FOOTNOTE_MATCH_REGEX = /#f_([\w-]+(,[\w-]+)*)#/g;

export function findFootnoteIdsInString(text: string): string[] {
    const matches = Array.from(text.matchAll(FOOTNOTE_MATCH_REGEX));
    const ids = new Set<string>();

    for (const match of matches) {
        const idsStr = match[1];
        for (const id of idsStr.split(',')) {
            ids.add(id);
        }
    }

    return Array.from(ids);
}
